export const Loading = require('../resources/img/loading.gif');
export const Check = require('../resources/img/check.webp');
export const Percentage = require('../resources/img/per.webp');
export const NoData = require('../resources/img/noRetailers.jpg');
export const Arrow = require('../resources/img/arrow_right.jpg');
export const Arrow_Disabled = require('../resources/img/arrow_right_disabled.jpg');
export const Unchecked = require('../resources/img/uncheck.png');
export const Checked = require('../resources/img/checked.png');
export const Shop_Icon = require('../resources/img/shop.png')
